import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "formulaire-creation-preavis" }
const _hoisted_2 = { class: "field-group objet-group" }
const _hoisted_3 = { class: "field-group delai-group" }
const _hoisted_4 = { class: "field-group emails-section" }
const _hoisted_5 = { class: "email-input" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = {
  key: 3,
  class: "email-list"
}
const _hoisted_8 = { class: "email-text" }
const _hoisted_9 = ["alt", "aria-label", "src", "onClick"]
const _hoisted_10 = {
  key: 4,
  class: "email-hint"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_ErrorMessageFormulaire = _resolveComponent("ErrorMessageFormulaire")!
  const _component_DropDown = _resolveComponent("DropDown")!
  const _component_ReglePastille = _resolveComponent("ReglePastille")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_TextInput, {
        modelValue: _ctx.objet,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.objet) = $event)),
        label: _ctx.$t('preavisIntervention.objet.libelle'),
        onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.touchedObjet = true))
      }, null, 8, ["modelValue", "label"]),
      (_ctx.touchedObjet && !_ctx.objetOk)
        ? (_openBlock(), _createBlock(_component_ErrorMessageFormulaire, {
            key: 0,
            message: _ctx.$t('preavisIntervention.objet.required')
          }, null, 8, ["message"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_DropDown, {
        display: _ctx.displayDelai,
        label: _ctx.$t('preavisIntervention.delai'),
        list: _ctx.delaiOptions,
        selectedItem: _ctx.selectedDelaiItem,
        onSelect: _ctx.onSelectDelai
      }, null, 8, ["display", "label", "list", "selectedItem", "onSelect"]),
      _createVNode(_component_ReglePastille, { cle: "preavisIntervention.delaiMax" })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_TextInput, {
          modelValue: _ctx.emailDraft,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.emailDraft) = $event)),
          label: _ctx.$t('preavisIntervention.emailsSuivi.libelle'),
          style: {"width":"100%"},
          onBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.touchedEmail = true)),
          onKeyup: _withKeys(_ctx.addEmail, ["enter"])
        }, null, 8, ["modelValue", "label", "onKeyup"]),
        _createElementVNode("button", {
          disabled: !_ctx.canAddEmail,
          class: "btn-add",
          type: "button",
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.addEmail && _ctx.addEmail(...args)))
        }, "+", 8, _hoisted_6),
        _createVNode(_component_ReglePastille, { cle: "preavisIntervention.emailsRegles" })
      ]),
      (_ctx.touchedEmail && _ctx.isDuplicateEmail)
        ? (_openBlock(), _createBlock(_component_ErrorMessageFormulaire, {
            key: 0,
            message: _ctx.$t('preavisIntervention.emailsSuivi.duplicate')
          }, null, 8, ["message"]))
        : _createCommentVNode("", true),
      (_ctx.touchedEmail && _ctx.emailDraft.trim().length > 0 && !_ctx.isValidEmail(_ctx.emailDraft) && !_ctx.isDuplicateEmail)
        ? (_openBlock(), _createBlock(_component_ErrorMessageFormulaire, {
            key: 1,
            message: _ctx.$t('preavisIntervention.emailsSuivi.invalid')
          }, null, 8, ["message"]))
        : _createCommentVNode("", true),
      (_ctx.touchedEmail && _ctx.emails.length >= _ctx.loadMaxMailPreavis)
        ? (_openBlock(), _createBlock(_component_ErrorMessageFormulaire, {
            key: 2,
            message: _ctx.$t('preavisIntervention.emailsSuivi.max')
          }, null, 8, ["message"]))
        : _createCommentVNode("", true),
      (_ctx.emails.length > 0)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.emails, (mail, idx) => {
              return (_openBlock(), _createElementBlock("li", {
                key: mail + idx,
                class: "email-item"
              }, [
                _createElementVNode("span", _hoisted_8, _toDisplayString(mail), 1),
                (mail !== _ctx.lockedEmail)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      alt: `${_ctx.$t('bouton.supprimer')} ${mail}`,
                      "aria-label": `${_ctx.$t('bouton.supprimer')} ${mail}`,
                      src: _ctx.loadIconDelete,
                      class: "email-remove",
                      onClick: ($event: any) => (_ctx.removeEmail(idx))
                    }, null, 8, _hoisted_9))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_ctx.$t('preavisIntervention.mail.empty')), 1))
    ])
  ]))
}